/*
 * @Author: 王琪瑞
 * @Date: 2021-03-25 16:40:55
 * @LastEditTime: 2021-04-14 13:57:41
 * @LastEditors: 王琪瑞
 */
import {
  computed, reactive, onMounted,
} from 'vue';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import { MessageApi } from 'ant-design-vue/lib/message/index.d';
import axios from '@/axios/api';
import { definitions } from '@/types/api';
import { ScenarioConstructionStep, StepStatus } from './interface';

const scenarioConstructionSteps: ScenarioConstructionStep[] = [
  { title: '角色信息', value: 0, disable: false },
  { title: '对话信息', value: 1, disable: false },
  { title: '物品信息', value: 2, disable: false },
  { title: '推演设定', value: 3, disable: false },
  { title: '风险分析', value: 4, disable: false },
  { title: '推演分析', value: 5, disable: false },
  { title: '任务清单', value: 6, disable: false },
];

export interface SceneConstructI {
  // 案例id
  caseId: string;

  // 步骤当前位置
  stepIndex: number;

  // 步骤列表
  steps: ScenarioConstructionStep[];

  // 步骤状态
  stepStatus: StepStatus;
}

export class SceneConstruct implements SceneConstructI {
  caseId = '';

  stepIndex = 0;

  steps: ScenarioConstructionStep[] = scenarioConstructionSteps;

  stepStatus: StepStatus = {
    caseId: '',
    status: [],
    stepStatus: '',
  };

  constructor(caseId: string) {
    this.caseId = caseId;
    this.stepStatus.caseId = caseId;
    this.initializeStepStatus();
  }

  /**
   * 修改步骤状态
   * @param index 当前步骤
   * @param status 完成状态
   */
  // changeStepStatus(index: number = this.stepIndex, status = true) {
  //   this.stepStatus[index].status = status;
  //   this.stepStatus[index].stepStatus = status.toString();
  // }

  /**
   * 校验步骤状态
   * @param index 当前步骤
   * @returns true 当前步骤已完成 ，false 当前步骤未完成
   */
  checkStepStatus(index: number = this.stepIndex): boolean {
    return this.stepStatus.status[index];
  }

  /**
   * 初始化步骤状态
   */
  initializeStepStatus() {
    this.stepStatus.status.splice(0);
    for (let i = 0; i < this.steps.length; i += 1) {
      this.stepStatus.status.push(false);
    }
    this.stepStatus.stepStatus = JSON.stringify(this.stepStatus.status);
  }

  /**
   * 根据案例Id获取案例情景构建步骤状态
   */
  async query() {
    try {
      const statusRequest: definitions['CustomCaseStatus'] = (await axios.getStatusByCaseId(this.caseId)).data.data;

      if (statusRequest && Array.isArray(statusRequest.stepStatus ? JSON.parse(statusRequest.stepStatus) : false)) {
        Object.assign(this.stepStatus, statusRequest);
        this.stepStatus.status = JSON.parse(this.stepStatus.stepStatus);
      } else {
        this.initializeStepStatus();
      }
    } catch (err) {
      throw new Error(err);
    }
  }

  /**
   * 编辑案例情景构建步骤状态
   * @param index 当前步骤
   * @param status 完成状态
   */
  async edit(index: number = this.stepIndex, status = true) {
    try {
      const arr = [...this.stepStatus.status];
      arr[index] = status;
      const statusData: definitions['CustomCaseStatus'] = {
        caseId: this.caseId,
        stepStatus: JSON.stringify(arr),
        id: this.stepStatus.id,
      };
      if (!statusData.id) delete statusData.id;
      const { data } = (await axios.editCustomCaseStatus(statusData)).data;
      Object.assign(this.stepStatus, data);
      this.stepStatus.status[index] = status;
      message.success('保存成功！');
    } catch (err) {
      throw new Error(err);
    }
  }
}

export default (Message: MessageApi = message) => {
  // 路由
  const route = useRoute();

  // 案例id
  const caseId: string = Array.isArray(route.params.caseId) ? '' : route.params.caseId;

  // 情景构建实例
  const sceneConstructModule = reactive(new SceneConstruct(caseId));

  // 当前步骤名称
  const stepName = computed(
    () => sceneConstructModule.steps.find((e) => e.value === sceneConstructModule.stepIndex)?.title,
  );

  // 第一个未完成步骤
  const firstStep = computed(() => sceneConstructModule.stepStatus.status.findIndex((e) => !e));

  // 步骤保存
  const saveStep = (): void => {
    sceneConstructModule.edit();
  };

  // 下一步
  const nextStep = () => {
    if (sceneConstructModule.checkStepStatus()) {
      sceneConstructModule.stepIndex += 1;
      return;
    }
    Message.error('请依次完成页面信息！');
  };

  // 步骤点击切换
  const stepsChange = (value: number) => {
    if (sceneConstructModule.stepStatus.status[value] || value === firstStep.value) {
      sceneConstructModule.stepIndex = value;
    } else {
      Message.error('请依次完成页面信息！');
    }
  };

  // 获取当前步骤显示状态
  const getStepStatus = (value: number) => {
    if (value === sceneConstructModule.stepIndex) {
      return 'process';
    }
    if (sceneConstructModule.stepStatus.status[value]) {
      return 'finish';
    }
    return 'wait';
  };

  onMounted(async () => {
    await sceneConstructModule.query();
  });

  return {
    sceneConstructModule,
    route,
    stepName,
    firstStep,
    nextStep,
    saveStep,
    stepsChange,
    getStepStatus,
  };
};
